import Hero from "../components/Hero";
import EditorialMarquee from "../components/EditorialMarquee";
import About from "../components/About";
import Services from "../components/Services";
import Offers from "../components/Offers";
import ContactSection from "../components/ContactSection";
import { useContent, useT } from "../context/ContentContext";

export default function HomePage() {
  const { content } = useContent();
  const t = useT();
  if (!content) return null;

  return (
    <main data-testid="home-page">
      <div className="noise-overlay" />
      <Hero />
      <EditorialMarquee items={t("marquee_items")} />
      <About content={content} />
      <Services />
      <Offers />
      <ContactSection content={content} />
    </main>
  );
}
